
meedy.constant('meedyConfig', {
    APPLICATION_CUSTOMER:   'Enterprise Software',
    APPLICATION_NAME:       'Kalendarz Meedy',
    VERSION:                '0.0.1',
    API_URL:                'https://kalendarz.meedy.pl/backend/rest/v1',
    DEMO_URL:               'https://kalendarz.meedy.pl/backend/rest/v1/demo',
    AUTH_URL_CAS:           'https://auth.meedy.pl/sso/login',
    AUTH_URL_MDX:           'https://app.medatex.pl/loginByToken',
    AUTH_URL_MEEDY:         'https://kalendarz.meedy.pl/backend/messagebroker/oauth/token',
    LOGOUT_URL:             'https://auth.meedy.pl/sso/logout',
    FILE_DOWNLOAD_PREFIX:   'https://kalendarz.meedy.pl/backend/messagebroker',
    MDX_FILE_DOWNLOAD_PREFIX:   'https://www.icrmed.pl/icrfiles/messagebroker/servlet',
    MDX_API_URL:            'https://app.medatex.pl/api',
    DOMAIN:                 '.meedy.pl',
    DEV_MODE:               false,
    DEMO:                   false,
    ANALYTICS:              false,
    ANALYTICS_CODE:         '',
    COMPANY:                '[COMPANY]',
    TAWK_TO: {
        KEY: '5badde4f181d3a551971ff8c'
    },
    SOCKET_URL: {
        REGISTER:           'https://kalendarz.meedy.pl/backend/messagebroker/api/v1/chat',
        PATIENT_CALL:       '/panel/patientCall',
        PREFIX:             '/user/',
        CALL_ANSWERED:      '/panel/callAnswered',
        EXAMINATION_RESULT: '/panel/examinationResult',
        UPDATE_VIDEO_ATTACHMENTS_LIST: '/panel/updateAttachmentsList'
    }
});

